import React from "react"
import { LeftWave, RightWave } from "components/Elements"

export const WavesBicycode: React.FC = () => {
	const mainUrl =
		process.env.REACT_APP_MODE === "production"
			? `${window.location.origin}`
			: `${process.env.PUBLIC_URL}`

	return (
		<>
			<LeftWave className="fixed bottom-0 left-0" />
			<RightWave className="fixed bottom-0 right-0" />

			<img
				src={`${mainUrl}/images/Chevalier_2.png`}
				alt=""
				width="460"
				height="460"
				className="hidden lg:block fixed bottom-2 right-0"
			/>
		</>
	)
}
